import { object } from 'prop-types'
import Buttons from '@ui/elements/Buttons'
import CheckboxType from '@ui/inputs/CheckboxType'
import DateType from '@ui/inputs/DateType'
import Dropzone from '@ui/inputs/Dropzone'
import FileType from '@ui/inputs/FileType'
import RadioType from '@ui/inputs/RadioType'
import SelectType from '@ui/inputs/SelectType'
import TextareaType from '@ui/inputs/TextareaType'
import TextType from '@ui/inputs/TextType'
import TinymceType from '@ui/inputs/TinymceType'
import HugerteType from '@ui/inputs/HugerteType'
import Div from '@ui/layout/Div'
import SwitcherType from '@ui/inputs/SwitcherType'
import FunctionType from '@ui/inputs/FunctionType'
import PlaceAutocomplete from '@ui/inputs/PlaceAutocomplete'

const getField = (field, callback, callbackWithPropValue = () => { }) => {
  switch (field.type) {
    case 'text':
    case 'email':
    case 'number':
    case 'password':
    case 'url':
      return <TextType
        name={field.name}
        onChange={callback}
        cssClass={field.cssClass}
        type={field.type}
        value={field.value}
        placeholder={field.placeholder}
        key={field.key}
        onBlur={field.onBlur}
        disabled={field.disabled}
        label={field.label}
        help={field.help}
        prepend={field.prepend}
        leftPrepend={field.leftPrepend}
        rightPrepend={field.rightPrepend}
        max={field.max}
        min={field.min}
        step={field.step}
        error={field.error}
        isRequired={field.isRequired}
      />
    case 'date':
      return <DateType
        name={field.name}
        onChange={callbackWithPropValue}
        cssClass={field.cssClass}
        value={field.value}
        placeholder={field.placeholder}
        key={field.key}
        label={field.label}
        help={field.help}
        disabled={field.disabled}
        error={field.error}
        isRequired={field.isRequired}
        isInline={field.isInline}
      />
    case 'places':
      return <PlaceAutocomplete
        name={field.name}
        onChange={callbackWithPropValue}
        cssClass={field.cssClass}
        placeholder={field.placeholder}
        key={field.key}
        disabled={field.disabled}
        label={field.label}
        help={field.help}
        error={field.error}
        isRequired={field.isRequired}
        centerCoordinates={field.centerCoordinates}
        country={field.country}
        targetMairie={field.targetMairie}
        targetZipCode={field.targetZipCode}
        zipCodeField={field.zipCodeField}
      />
    case 'textarea':
      return <TextareaType
        name={field.name}
        onChange={callback}
        cssClass={field.cssClass}
        value={field.value}
        placeholder={field.placeholder}
        key={field.key}
        disabled={field.disabled}
        label={field.label}
        help={field.help}
        error={field.error}
        isRequired={field.isRequired}
      />
    case 'tinymce':
      return <TinymceType
        config={field.config}
        name={field.name}
        onChange={callbackWithPropValue}
        cssClass={field.cssClass}
        initialValue={field.initialValue}
        key={field.key}
        disabled={field.disabled}
        label={field.label}
        help={field.help}
        error={field.error}
        isRequired={field.isRequired}
        height={field.height}
      />
    case 'hugerte':
      return <HugerteType
        config={field.config}
        name={field.name}
        onChange={callbackWithPropValue}
        cssClass={field.cssClass}
        initialValue={field.initialValue}
        key={field.key}
        disabled={field.disabled}
        label={field.label}
        help={field.help}
        error={field.error}
        isRequired={field.isRequired}
        height={field.height}
      />
    case 'select':
      return <SelectType
        name={field.name}
        onChange={callback}
        cssClass={field.cssClass}
        canCreate={field.canCreate}
        creationUrl={field.creationUrl}
        creationModalCaller={field.creationModalCaller}
        formfields={field.formFields}
        withIcon={field.withIcon}
        icon={field.icon}
        options={field.options}
        value={field.value}
        fetchUrl={field.fetchUrl}
        disabled={field.disabled}
        label={field.label}
        help={field.help}
        key={field.key}
        error={field.error}
        isRequired={field.isRequired}
        isLinked={field.isLinked}
      />
    case 'file':
      return <FileType
        name={field.name}
        blobPoster={field.blobPoster}
        onChange={callbackWithPropValue}
        cssClass={field.cssClass}
        simpleInput={field.simpleInput}
        value={field.value}
        key={field.key}
        disabled={field.disabled}
        label={field.label}
        help={field.help}
        error={field.error}
        targetUrl={field.targetUrl}
        fileType={field.fileType}
        id={field.id}
      />
    case 'fileMultiple':
      return <Dropzone
        name={field.name}
        value={field.value}
        onChange={callbackWithPropValue}
        cssClass={field.cssClass}
        isActive={field.isActive}
        key={field.key}
        targetUrl={field.targetUrl}
        initialize={field.initialize}
        alt={field.alt ? field.alt : field.name}
        clearState={field.clearState}
        error={field.error}
        removeOldUploadedFileCallback={field.removeOldUploadedFileCallback}
        help={field.help}
      />
    case 'radio':
      return <RadioType
        name={field.name}
        onClick={callbackWithPropValue}
        cssClass={field.cssClass}
        canCreate={field.canCreate}
        creationModalCaller={field.creationModalCaller}
        options={field.options}
        value={field.value}
        key={field.key}
        label={field.label}
        help={field.help}
        error={field.error}
      />
    case 'checkbox':
      return <CheckboxType
        name={field.name}
        onClick={callbackWithPropValue}
        cssClass={field.cssClass}
        options={field.options}
        value={field.value}
        key={field.key}
        label={field.label}
        help={field.help}
        isMultiple={field.isMultiple}
        error={field.error}
        canCreate={field.canCreate}
        creationModalCaller={field.creationModalCaller}
      />
    case 'switcher':
      return <SwitcherType
        name={field.name}
        onClick={callback}
        cssClass={field.cssClass}
        switcherClass={field.switcherClass}
        value={"" !== field.value ? parseInt(field.value) : false}
        label={field.label}
        key={field.key}
        help={field.help}
        error={field.error}
        id={field.id}
        isRequired={field.isRequired}
      />
    case 'function':
      return <FunctionType
        callback={field.callback}
        cssClass={field.cssClass}
        key={field.key}
        error={field.error}
      />
    case 'button':
      if (field.ownButtons) {
        return (
          < Div cssClass={`formButtons ${field.cssClass}`} key={field.key} >
            <Buttons buttons={[...field.ownButtons]} />
          </Div >
        )
      } else if (field.buttons) {
        if (field.cancel) {
          return (
            <Div cssClass={`formButtons ${field.cssClassParent}`} key={field.key}>
              <Buttons buttons={[
                { icon: field.validateIcon || 'icon-checkmark', cssClass: `level-item ${field.cssClassValidate} ${field.isLoading ? 'is-loading' : ''}`, callback: e => field.callback(e), text: field.validateText, disabled: field.disabled },
                { icon: field.cancelIcon || 'icon-chevron-left ', cssClass: `level-item ${field.cssClassCancel}`, callback: field.cancelCallback, text: field.cancelText }
              ]} />
            </Div>
          )
        }
        return (
          <Div cssClass={`formButtons ${field.cssClass}`} key={field.key}>
            <Buttons buttons={{ icon: field.validateIcon || 'icon-checkmark', cssClass: `level-item ${field.cssClassValidate} ${field.isLoading ? 'is-loading' : ''}`, callback: e => field.callback(e), text: field.validateText, disabled: field.disabled }} />
          </Div>
        )
      }
  }
}

getField.propTypes = {
  field: object
}

export default getField
